import React, {Component} from 'react';
import {connect} from 'react-redux';
import SetUserPassword from "../components/setUserPassword";
import {changeUserSetPasswordSettings, requestPostUserSetPassword} from "../actions/setUserPassword";

class SetUserPasswordHOC extends Component {
	constructor(props) {
		super(props)

	}

	handleSubmit = (evt) => {
		evt.preventDefault();
		if(this.isPasswordInvalid()){
			return false;
		}

		let password = this.props.setUserPassword.password;
		let userId = this.props.setUserPassword.userId;
		let hashCode = this.props.setUserPassword.hashCode;
		let code = this.props.setUserPassword.code;
		let retypedPassword = this.props.setUserPassword.retypedPassword;
		if(password !== retypedPassword){
			this.props.changeUserSetPasswordSettings('badMsg', 'Passwords must match.')
		}
		else {
            let sendBody = {
                userId: userId,
                codePassword: hashCode,
                code: code,
                password: password
            };
            this.props.requestPostUserSetPassword(sendBody);
		}
	};

	componentWillMount = () => {
		let route = this.props.setUserPassword.pathSearch;
		let splitRoute = route.split(/\?userId=|\?codePassword=|\?code=/);
		this.props.changeUserSetPasswordSettings('hashCode', splitRoute[2]);
		this.props.changeUserSetPasswordSettings('userId', splitRoute[1]);
		this.props.changeUserSetPasswordSettings('code', splitRoute[3]);

	};

	isPasswordInvalid = () => {
		return (
            !this.props.setUserPassword.password.match(/[a-z]/) ||
            !this.props.setUserPassword.password.match(/[A-Z]/) ||
            !this.props.setUserPassword.password.match(/\d/) ||
            !this.props.setUserPassword.password.match(/\W/) ||
            this.props.setUserPassword.password.length < 8
		)
	};

	render() {
		return (
			<SetUserPassword
				handleSubmit={this.handleSubmit}
				store={this.props.setUserPassword}
                changeUserSetPasswordSettings={this.props.changeUserSetPasswordSettings}
                isPasswordInvalid={this.isPasswordInvalid()}
			/>
		)

	}
}

const mapStateToProps = (state) => {
	return {
        setUserPassword: state.setUserPassword,
		router: state.router
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		changeUserSetPasswordSettings: (key, value) => {
			dispatch(changeUserSetPasswordSettings(key, value))
		},
		requestPostUserSetPassword: (sendBody) => {
			dispatch(requestPostUserSetPassword(sendBody))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(SetUserPasswordHOC);